/**
 * English is included out of the box
 * To add new languages use strings in this array
 * e.g. 'de' for Deutsch or 'fr' for French
 */
export default [];
